<template>
  <div id="editor-view">
    <v-slide-group
      show-arrows mandatory
      v-if="$data.$_renderComponent"
      v-bind:value="$data.$_selectedEditorComponentName"
      v-on:change="$_selectEditor"
    >
      <template v-for="editorDefinition of editorDefinitions">
        <v-slide-item
          v-if="editorDefinition.isAvailable(timelineDataSet)"
          v-bind:key="editorDefinition.componentName"
          v-bind:value="editorDefinition.componentName"
          v-slot="{ active, toggle }"
        >
          <v-btn
            tile text small
            v-bind:input-value="active"
            v-bind:data-testid="editorDefinition.componentName"
            v-on:click="toggle"
            v-on:space="toggle"
          >
            {{ editorDefinition.title }}
          </v-btn>
        </v-slide-item>
      </template>
    </v-slide-group>

    <div id="editor-container">
      <component
        v-bind:is="$data.$_selectedEditorComponentName"
        v-bind:annotator-id="annotatorId"
        v-bind:annotator-name="annotatorName"
        v-bind:timeline-data-set="timelineDataSet"
        v-bind:selected-timeline-segment-ids="selectedTimelineSegmentIds"
      >
      </component>
    </div>
  </div>
</template>

<style scoped>
#editor-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: clip;
}

#editor-container {
  position: relative;
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>

<script>
import TimelineLabelEnumerator from './Editors/TimelineLabelEnumerator.vue';
import NoteEditor from './Editors/NoteEditor.vue';
import TimelineSegmentInspector from './Editors/TimelineSegmentInspector.vue';
import GeneralEditor from './Editors/GeneralEditor.vue';
import { TimelineLabelEnumeratorDefinition } from '../components/Editors/TimelineLabelEnumerator.vue';
import { NoteEditorDefinition } from '../components/Editors/NoteEditor.vue';
import { TimelineSegmentInspectorDefinition } from '../components/Editors/TimelineSegmentInspector.vue';
import { GeneralEditorDefinition } from '../components/Editors/GeneralEditor.vue';
import { TimelineDataSet } from '../modules/ScattData.js';

function generatePrefedinedComponents() {
  let predefinedComponents = {};
  predefinedComponents[TimelineLabelEnumeratorDefinition.componentName] = TimelineLabelEnumerator;
  predefinedComponents[NoteEditorDefinition.componentName] = NoteEditor;
  predefinedComponents[TimelineSegmentInspectorDefinition.componentName] = TimelineSegmentInspector;
  predefinedComponents[GeneralEditorDefinition.componentName] = GeneralEditor;
  return predefinedComponents;
}

const predefinedComponents = generatePrefedinedComponents();

export default {
  props: {
    annotatorId:                { type: String },
    annotatorName:              { type: String },
    timelineDataSet:            { type: TimelineDataSet },
    selectedTimelineSegmentIds: { type: Array },
    editorDefinitions:          { type: Array },
  },

  components: predefinedComponents,

  data() {
    return {
      $_renderComponent: true,
      $_selectedEditorComponentName: undefined,
      $_editorViewResizeObserver: new ResizeObserver(this.$_rerenderComponent),
    };
  },

  mounted() {
    this.$data.$_editorViewResizeObserver.observe(this.$el);
  },

  destroyed() {
    this.$data.$_editorViewResizeObserver.disconnect();
  },

  methods: {
    $_rerenderComponent() {
      this.$data.$_renderComponent = false;
      this.$nextTick(() => {
        this.$data.$_renderComponent = true;
      });
    },

    $_selectEditor(selectedEditorComponentName) {
      this.$data.$_selectedEditorComponentName = selectedEditorComponentName;
    },
  },
};
</script>
